module.exports = __webpack_public_path__ + "static/img/erweima.396e8a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/erweima.jpg
// module id = NjcT
// module chunks = 5